import { injectable, inject } from 'inversify';
import { SuspendDataStore, SuspendDataStoreSymbol, SuspendDataStateStore } from '@/app/tracking/common';
import { badgeStateReducer, BadgeReducerCommand } from './badge-state-reducer';
import { BadgeState, defaultBadgeState } from './badge-state';

interface BadgeSuspendData {
  badges: BadgeState[];
}

@injectable()
export class BadgeSuspendDataStateStore {

  private store: SuspendDataStateStore<BadgeState, unknown, BadgeReducerCommand>;

  constructor(
    @inject(SuspendDataStoreSymbol)
    suspendDataStore: SuspendDataStore<BadgeSuspendData>) {

    this.store = new SuspendDataStateStore(
      () => suspendDataStore.get2('badges'),
      (data: BadgeState[]) => suspendDataStore.update2('badges', data),
      (id) => defaultBadgeState(id),
      badgeStateReducer);
  }

  public async query(ids: string[] | 'all') {
    return this.store.query(ids);
  }

  public async execute(command: BadgeReducerCommand) {
    await this.store.execute(command);
  }
}
